import Marquee from "react-fast-marquee";
import { TAGLINES } from "@/data/catalog";
import { Asterisk } from "lucide-react";

export default function Ribbon() {
  return (
    <section
      data-testid="section-ribbon"
      className="border-y border-[#3A4536]/10 bg-[#EAE5D9] py-10"
    >
      <Marquee speed={30} gradient={false} autoFill>
        {TAGLINES.map((t, i) => (
          <div key={i} className="flex items-center gap-24 pr-24">
            <span className="font-serif-display text-3xl font-light italic text-[#1A2118] md:text-5xl">
              {t}
            </span>
            <Asterisk strokeWidth={1} className="h-8 w-8 text-[#B85D43]" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
